export default "__VITE_ASSET__DOkY0EXe__"